import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Divider, Box, Typography} from 'views/components';

import {Translate} from 'views/module';

import moment from 'moment';

const HOURLY_RATE = 35; // $35 per hour

const SlipHourOverview = ({slipDetail}) => {
  const {hours} = slipDetail;

  // Calculate total hours
  const totalHours = hours.reduce((sum, shift) => {
    const start = moment(shift.eventData.startTime);
    const end = moment(shift.eventData.endTime);
    return sum + moment.duration(end.diff(start)).asHours();
  }, 0);

  // Calculate confirmed hours
  const confirmedHours = hours.reduce((sum, shift) => {
    if (shift.clockOutConfirmation) {
      const start = moment(shift.eventData.startTime);
      const end = moment(shift.eventData.endTime);
      return sum + moment.duration(end.diff(start)).asHours();
    }
    return sum;
  }, 0);

  // Calculate total costs
  const totalCost = totalHours * HOURLY_RATE;
  const confirmedCost = confirmedHours * HOURLY_RATE;

  return (
    <Stack sx={{p: 2}} spacing={2}>
      <Typography sx={{fontWeight: 'bold', fontSize: '1.2rem'}}>
        <Translate expression='client.ClientDetail.Payment.WorkSummary.Title' />
      </Typography>
      <Divider />
      <Box sx={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2}}>
        <Box>
          <Typography sx={{fontWeight: 'bold'}}>
            <Translate expression='client.ClientDetail.Payment.WorkSummary.TotalHours' />
          </Typography>
          <Typography>
            <Translate expression='client.ClientDetail.Payment.HoursDisplay' substitute={{hours: totalHours.toFixed(2)}} />
          </Typography>
        </Box>
        <Box>
          <Typography sx={{fontWeight: 'bold'}}>
            <Translate expression='client.ClientDetail.Payment.WorkSummary.TotalCost' />
          </Typography>
          <Typography>
            <Translate expression='client.ClientDetail.Payment.CostDisplay' substitute={{cost: totalCost.toFixed(2)}} />
          </Typography>
        </Box>
      </Box>
      <Box sx={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2}}>
        <Box>
          <Typography sx={{fontWeight: 'bold'}}>
            <Translate expression='client.ClientDetail.Payment.WorkSummary.ConfirmedHours' />
          </Typography>
          <Typography>
            <Translate expression='client.ClientDetail.Payment.HoursDisplay' substitute={{hours: confirmedHours.toFixed(2)}} />
          </Typography>
        </Box>
        <Box>
          <Typography sx={{fontWeight: 'bold'}}>
            <Translate expression='client.ClientDetail.Payment.WorkSummary.ConfirmedCost' />
          </Typography>
          <Typography>
            <Translate expression='client.ClientDetail.Payment.CostDisplay' substitute={{cost: confirmedCost.toFixed(2)}} />
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
};

SlipHourOverview.propTypes = {
  slipDetail: PropTypes.object.isRequired,
};

export default React.memo(SlipHourOverview);
